import { navLinks, profile } from "../data";

function Navbar() {
  return (
    <header className="nav-wrap">
      <nav className="nav container">
        <a href="#home" className="nav-brand">
          {profile.name}
        </a>

        <ul className="nav-links">
          {navLinks.filter((link) => link.href !== "#contact").map((link) => (
            <li key={link.href}>
              <a href={link.href}>{link.label}</a>
            </li>
          ))}
        </ul>

        <a href="#contact" className="nav-cta">
          <span className="status-dot" />
          Contact
        </a>
      </nav>
    </header>
  );
}

export default Navbar;
